import * as types from '../mutation-types'
import { stateManager } from '../helper'

const sm = stateManager({
  data: [],
  selecting: false,
  processing: false
})

export default {
  namespaced: true,
  state: sm.get(),
  mutations: {
    [types.SELECTION_START_SELECTING] (state) {
      state.selecting = true
    },
    [types.SELECTION_END_SELECTING] (state) {
      state.selecting = false
    },
    [types.SELECTION_START_PROCESSING] (state) {
      state.processing = true
    },
    [types.SELECTION_END_PROCESSING] (state) {
      state.processing = false
    },
    [types.SELECTION_EMPTY_DATA] (state) {
      state.data = []
    },
    [types.SELECTION_SET_DATA] (state, data) {
      state.data = data
    }
  },
  actions: {
    enable ({ commit }) {
      commit(types.SELECTION_START_SELECTING)
    },
    disable ({ commit }) {
      commit(types.SELECTION_EMPTY_DATA)
      commit(types.SELECTION_END_SELECTING)
    },
    setData ({ commit }, data) {
      commit(types.SELECTION_SET_DATA, data)
    }
  },
  getters: {
    dataNum (state) {
      return state.data.length
    }
  }
}
